import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../api/axiosInstance";

export const getSingleAdminFunc = createAsyncThunk(
  "getSingleAdmin",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/admins/${id}`);
      return response.data.data.admin;
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data || { message: error.message }
      );
    }
  }
);

const getSingleAdminSlicer = createSlice({
  name: "getSingleAdmin",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
    successMessage: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleAdminFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleAdminFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.successMessage = action.payload?.message || "";
      })
      .addCase(getSingleAdminFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleAdminSlicer.reducer;
